// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Julius+Sans+One);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loading_main__P5hoL{
  /* background: white; */
  /* width: 100%;
  height: 100%; */
  position: fixed;
  /* display: block; */
  z-index: 100;
}


.loading_eye__wp-el {
  width: 20px;
  height: 8px;
  background-color: rgb(0, 0, 0);
  border-radius: 0px 0px 20px 20px;
  position: relative;
  left: 10px;
  top: 40px;
  box-shadow: 40px 0px 0px 0px rgb(0, 0, 0);
}

.loading_head__1Yjja {
  backface-visibility: hidden;
  position: relative;
  margin: -250px auto;
  width: 80px;
  height: 80px;
  background-color: #ffffff;
  border-radius: 50px;
  box-shadow: inset -4px 2px 0px 0px rgb(0, 0, 0);
  animation: loading_headAnim__9OuSG 1.5s infinite alternate;
  animation-timing-function: ease-out;
}

.loading_body__ylsFh {
  position: relative;
  margin: 90px auto;
  width: 140px;
  height: 120px;
  background-color: #ffffff;
  border-radius: 50px/25px;
  box-shadow: inset -5px 2px 0px 0px rgb(0, 0, 0);
  animation: loading_bodyAnim__45NTX 1.5s infinite alternate;
  animation-timing-function: ease-out;
}

@keyframes loading_headAnim__9OuSG {
  0% {
    top: 0px;
  }
  50% {
    top: 10px;
  }
  100% {
    top: 0px;
  }
}

@keyframes loading_bodyAnim__45NTX {
  0% {
    top: -5px;
  }
  50% {
    top: 10px;
  }
  100% {
    top: -5px;
  }
}

.loading_circ__l3YXz {
  
  backface-visibility: hidden;
  margin: 20px auto;
  width: 180px;
  height: 180px;
  background-color: #ffffff;
  border-radius: 0px 0px 40px 40px;
  position: relative;
  /* z-index: -1; */
  left: 0%;
  top: 20%;
  overflow: hidden;
}

.loading_hands__7e-Ev {
  backface-visibility: hidden;
  margin-top: 140px;
  width: 120px;
  height: 120px;
  position: absolute;
  background-color: #ffffff;
  border-radius: 20px;
  box-shadow: -1px -4px 0px 0px rgb(7, 7, 7);
  transform: rotate(45deg);
  top: 75%;
  left: 16%;
  z-index: 1;
  animation: loading_bodyAnim__45NTX 1.5s infinite alternate;
  animation-timing-function: ease-out;
}

.loading_load__5\\+vwJ {
  position: absolute;
  width: 9ch;
  height: 32px;
  text-align: left;
  line-height: 32px;
  margin: -10px auto;
  -webkit-font-smoothing: antialiased;
  font-family: "Julius Sans One", sans-serif;
  font-size: 28px;
  font-weight: 700;
  color: rgb(17, 17, 17);
  left: 2%;
  top: 5%;
  animation: loading_fontAnim__sRYeU 3.75s infinite;
  animation-timing-function: ease-out;
  word-wrap: break-word;
  display: block;
  overflow: hidden;
}

@keyframes loading_fontAnim__sRYeU {
  0% {
    width: 7ch;
  }
  16% {
    width: 8ch;
  }
  32% {
    width: 9ch;
  }
  48% {
    width: 10ch;
  }
  64% {
    width: 11ch;
  }
  80% {
    width: 12ch;
  }
  100% {
    width: 13ch;
  }
}
`, "",{"version":3,"sources":["webpack://./src/style/loading.module.css"],"names":[],"mappings":"AAEA;EACE,uBAAuB;EACvB;iBACe;EACf,eAAe;EACf,oBAAoB;EACpB,YAAY;AACd;;;AAGA;EACE,WAAW;EACX,WAAW;EACX,8BAA8B;EAC9B,gCAAgC;EAChC,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,yCAAyC;AAC3C;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,+CAA+C;EAC/C,0DAA2C;EAC3C,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,wBAAwB;EACxB,+CAA+C;EAC/C,0DAA2C;EAC3C,mCAAmC;AACrC;;AAEA;EACE;IACE,QAAQ;EACV;EACA;IACE,SAAS;EACX;EACA;IACE,QAAQ;EACV;AACF;;AAEA;EACE;IACE,SAAS;EACX;EACA;IACE,SAAS;EACX;EACA;IACE,SAAS;EACX;AACF;;AAEA;;EAEE,2BAA2B;EAC3B,iBAAiB;EACjB,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,gCAAgC;EAChC,kBAAkB;EAClB,iBAAiB;EACjB,QAAQ;EACR,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,iBAAiB;EACjB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,0CAA0C;EAC1C,wBAAwB;EACxB,QAAQ;EACR,SAAS;EACT,UAAU;EACV,0DAA2C;EAC3C,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,mCAAmC;EACnC,0CAA0C;EAC1C,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,QAAQ;EACR,OAAO;EACP,iDAAkC;EAClC,mCAAmC;EACnC,qBAAqB;EACrB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;AACF","sourcesContent":["@import url(https://fonts.googleapis.com/css?family=Julius+Sans+One);\r\n\r\n.main{\r\n  /* background: white; */\r\n  /* width: 100%;\r\n  height: 100%; */\r\n  position: fixed;\r\n  /* display: block; */\r\n  z-index: 100;\r\n}\r\n\r\n\r\n.eye {\r\n  width: 20px;\r\n  height: 8px;\r\n  background-color: rgb(0, 0, 0);\r\n  border-radius: 0px 0px 20px 20px;\r\n  position: relative;\r\n  left: 10px;\r\n  top: 40px;\r\n  box-shadow: 40px 0px 0px 0px rgb(0, 0, 0);\r\n}\r\n\r\n.head {\r\n  backface-visibility: hidden;\r\n  position: relative;\r\n  margin: -250px auto;\r\n  width: 80px;\r\n  height: 80px;\r\n  background-color: #ffffff;\r\n  border-radius: 50px;\r\n  box-shadow: inset -4px 2px 0px 0px rgb(0, 0, 0);\r\n  animation: headAnim 1.5s infinite alternate;\r\n  animation-timing-function: ease-out;\r\n}\r\n\r\n.body {\r\n  position: relative;\r\n  margin: 90px auto;\r\n  width: 140px;\r\n  height: 120px;\r\n  background-color: #ffffff;\r\n  border-radius: 50px/25px;\r\n  box-shadow: inset -5px 2px 0px 0px rgb(0, 0, 0);\r\n  animation: bodyAnim 1.5s infinite alternate;\r\n  animation-timing-function: ease-out;\r\n}\r\n\r\n@keyframes headAnim {\r\n  0% {\r\n    top: 0px;\r\n  }\r\n  50% {\r\n    top: 10px;\r\n  }\r\n  100% {\r\n    top: 0px;\r\n  }\r\n}\r\n\r\n@keyframes bodyAnim {\r\n  0% {\r\n    top: -5px;\r\n  }\r\n  50% {\r\n    top: 10px;\r\n  }\r\n  100% {\r\n    top: -5px;\r\n  }\r\n}\r\n\r\n.circ {\r\n  \r\n  backface-visibility: hidden;\r\n  margin: 20px auto;\r\n  width: 180px;\r\n  height: 180px;\r\n  background-color: #ffffff;\r\n  border-radius: 0px 0px 40px 40px;\r\n  position: relative;\r\n  /* z-index: -1; */\r\n  left: 0%;\r\n  top: 20%;\r\n  overflow: hidden;\r\n}\r\n\r\n.hands {\r\n  backface-visibility: hidden;\r\n  margin-top: 140px;\r\n  width: 120px;\r\n  height: 120px;\r\n  position: absolute;\r\n  background-color: #ffffff;\r\n  border-radius: 20px;\r\n  box-shadow: -1px -4px 0px 0px rgb(7, 7, 7);\r\n  transform: rotate(45deg);\r\n  top: 75%;\r\n  left: 16%;\r\n  z-index: 1;\r\n  animation: bodyAnim 1.5s infinite alternate;\r\n  animation-timing-function: ease-out;\r\n}\r\n\r\n.load {\r\n  position: absolute;\r\n  width: 9ch;\r\n  height: 32px;\r\n  text-align: left;\r\n  line-height: 32px;\r\n  margin: -10px auto;\r\n  -webkit-font-smoothing: antialiased;\r\n  font-family: \"Julius Sans One\", sans-serif;\r\n  font-size: 28px;\r\n  font-weight: 700;\r\n  color: rgb(17, 17, 17);\r\n  left: 2%;\r\n  top: 5%;\r\n  animation: fontAnim 3.75s infinite;\r\n  animation-timing-function: ease-out;\r\n  word-wrap: break-word;\r\n  display: block;\r\n  overflow: hidden;\r\n}\r\n\r\n@keyframes fontAnim {\r\n  0% {\r\n    width: 7ch;\r\n  }\r\n  16% {\r\n    width: 8ch;\r\n  }\r\n  32% {\r\n    width: 9ch;\r\n  }\r\n  48% {\r\n    width: 10ch;\r\n  }\r\n  64% {\r\n    width: 11ch;\r\n  }\r\n  80% {\r\n    width: 12ch;\r\n  }\r\n  100% {\r\n    width: 13ch;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main": `loading_main__P5hoL`,
	"eye": `loading_eye__wp-el`,
	"head": `loading_head__1Yjja`,
	"headAnim": `loading_headAnim__9OuSG`,
	"body": `loading_body__ylsFh`,
	"bodyAnim": `loading_bodyAnim__45NTX`,
	"circ": `loading_circ__l3YXz`,
	"hands": `loading_hands__7e-Ev`,
	"load": `loading_load__5+vwJ`,
	"fontAnim": `loading_fontAnim__sRYeU`
};
export default ___CSS_LOADER_EXPORT___;
